import { useMemo } from 'react'

import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'

type Options = { label: string; value: uui.domain.server.rm.FlowRequirement }[]

type Props = {
  name: 'includePicture' | 'includeSignature' | 'includeAudio' | 'includeNote' // Fields of type uui.domain.server.rm.FlowRequirement
  disabled: boolean
}

export function OrdersType(props: Props) {
  const { name, disabled: fieldDisabled } = props

  const texts = useTexts()

  const options: Options = useMemo(
    () => [
      { label: texts.notCompleted, value: 'REQUIRED_TO_NOT_COMPLETE' },
      { label: texts.completed, value: 'REQUIRED_TO_COMPLETE' },
      { label: texts.all, value: 'ALWAYS_REQUIRED' },
    ],
    [texts],
  )

  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()

  const disableField = submitting || disabled || fieldDisabled

  return (
    <form.Fieldset paddingLeft={4}>
      <form.RadioGroup
        label={texts.whenRequired}
        name={name}
        options={options}
        validateOn="blur change"
        disabled={disableField}
        testId={`driver-assistance-form-${name}-orders-type-field`}
        radioGroupProps={{
          sx: { marginLeft: 1 },
        }}
      />
    </form.Fieldset>
  )
}
